import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const ProgressBar = ({ children }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + 100 / (3000 / 20);
        return newProgress >= 100 ? 100 : newProgress;
      });
    }, 20);

    return () => clearInterval(intervalId);
  }, []);

  if (progress === 100) {
    return <>{children}</>;
  }

  return (
    <>
      <div className="relative bg-gray-300 h-5">
        <div className="absolute bottom-0 inset-0">
          <div className="h-full bg-primary-500" style={{ width: `${progress}%` }} />
        </div>
      </div>
      {children}
    </>
  );
};

ProgressBar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProgressBar;
